import React, { Component, Fragment } from 'react';
import { compose } from 'recompose';
import { MutationFunction } from 'react-apollo';
import { ApolloError } from 'apollo-client';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Hidden, Typography } from '@material-ui/core';
import { Trans } from 'react-i18next';

import i18next from 'i18next';
import { UpdateUserProfileComponent } from 'api';
import { onboardingFollows } from 'paths';
import { withUser, withErrorHandler, IWithUser, IWithErrorHandler } from 'providers';
import { ClientLogo, Error, Layouts } from 'components';
import { getFullName } from 'helpers';

import { Form, ImageUpload, Main } from '../components';

interface IPropsEnhanced extends IWithUser, IWithErrorHandler, RouteComponentProps {}

interface IState {
  working: boolean;
}

interface IFormValues {
  full_name: string;
  job_title: string;
  location_id: string;
  department_id: string;
}

const FORM_HEIGHT = 450;

const enhancers = compose<IPropsEnhanced, {}>(withUser, withErrorHandler, withRouter);

class Profile extends Component<IPropsEnhanced, IState> {
  state: IState = {
    working: false,
  };

  handleCompleted = () => {
    const { history } = this.props;

    this.setState({ working: false }, () => {
      history.push(onboardingFollows);
    });
  };

  handleError = (error: ApolloError) => {
    const { onError } = this.props;
    this.setState({ working: false }, () => onError(error));
  };

  onSubmit = (updateUserProfile: MutationFunction) => (values: IFormValues) => {
    const { user } = this.props;
    const { department_id, location_id, ...rest } = values;

    const variables = {
      data: {
        id: user.id,
        last_onboarding_step: 1,
        lang: i18next.language,
        department_id: department_id ? department_id : null,
        location_id: location_id ? location_id : null,
        ...rest,
      },
    };

    window.Intercom &&
      window.Intercom('update', {
        user_id: user.id,
        name: getFullName(values),
        job_title: values.job_title,
      });

    this.setState({ working: true });

    return updateUserProfile({ variables });
  };

  renderError() {
    const { error, onErrorClose } = this.props;

    return <Error key={error} message={error} onClose={onErrorClose} />;
  }

  renderSidebar() {
    const { working } = this.state;

    return (
      <UpdateUserProfileComponent onError={this.handleError} onCompleted={this.handleCompleted}>
        {updateUserProfile => (
          <Fragment>
            {this.renderError()}
            <ClientLogo />
            <Typography color="textSecondary" gutterBottom variant="h4">
              <Trans i18nKey="onboarding:sidebarProfileHeader" />
            </Typography>
            <ImageUpload />
            <div style={{ minHeight: FORM_HEIGHT }}>
              <Form onSubmit={this.onSubmit(updateUserProfile)} working={working} />
            </div>
          </Fragment>
        )}
      </UpdateUserProfileComponent>
    );
  }

  render() {
    return (
      <Layouts.Full2Column
        sidebar={this.renderSidebar()}
        main={
          <Hidden xsDown>
            <Main />
          </Hidden>
        }
      />
    );
  }
}

export default enhancers(Profile);
